import { Box, Stack, Typography, type SxProps } from '@mui/material';
import React from 'react';

interface ResultProps {
    icon?: React.ReactNode;
    title: string;
    description: string;
    children?: React.ReactNode;
    sx?: SxProps;
}

const Result = ({ icon, title, description, children, sx }: ResultProps) => {
    return (
        <Stack
            direction="column"
            sx={{ alignItems: 'center', justifyContent: 'center', py: 8, ...sx }}
        >
            {icon && <Box sx={{ mb: { xs: 2, sm: 0 }, mr: { sm: 3 } }}>{icon}</Box>}

            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: children ? 3 : 0 }}>
                {description}
            </Typography>
            {children}
        </Stack>
    );
};

export default Result;
